var _style, _g, _g2, _title, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _path10, _path11, _path12, _path13, _defs, _g5, _defs2, _g6, _defs3, _g7, _path14, _title2, _path15, _path16, _circle, _path17, _circle2, _circle3, _text, _circle4, _circle5, _text2, _circle6, _circle7, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 487.9 366.2",
    style: {
      enableBackground: "new 0 0 487.9 366.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1E6FB;}\n\t.st1{fill:#BAC5F4;}\n\t.st2{fill:#F8F8FF;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F5F5FC;}\n\t.st5{font-family:'RevaloModernBold';}\n\t.st6{font-size:28px;}\n\t.st7{fill:#4B49BB;}\n\t.st8{fill:url(#SVGID_1_);}\n\t.st9{fill:url(#SVGID_2_);}\n\t.st10{fill:url(#SVGID_3_);}\n\t.st11{fill:url(#SVGID_4_);}\n\t.st12{opacity:7.000000e-02;enable-background:new    ;}\n\t.st13{fill:#4B44BE;}\n\t.st14{fill:url(#SVGID_5_);}\n\t.st15{fill:url(#SVGID_6_);}\n\t.st16{fill:url(#SVGID_7_);}\n\t.st17{fill:url(#SVGID_8_);}\n\t.st18{opacity:7.000000e-02;}\n\t.st19{clip-path:url(#SVGID_10_);}\n\t.st20{clip-path:url(#SVGID_12_);}\n\t.st21{clip-path:url(#SVGID_14_);}\n\t.st22{fill:url(#SVGID_15_);}\n\t.st23{fill:none;stroke:#F93764;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st24{fill:#F7B14A;}\n\t.st25{fill:none;stroke:url(#SVGID_16_);stroke-linecap:round;stroke-linejoin:round;}\n\t.st26{fill:url(#SVGID_17_);}\n\t.st27{fill:none;stroke:url(#SVGID_18_);stroke-miterlimit:10;}\n\t.st28{fill:#F9B449;}\n\t.st29{font-family:'ArialMT';}\n\t.st30{font-size:8.6848px;}\n\t.st31{fill:url(#SVGID_19_);}\n\t.st32{fill:none;stroke:url(#SVGID_20_);stroke-miterlimit:10;}\n\t.st33{font-size:5.7162px;}\n\t.st34{fill:url(#SVGID_21_);}\n\t.st35{fill:none;stroke:url(#SVGID_22_);stroke-miterlimit:10;}\n\t.st36{font-size:4.0904px;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 88.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -60.6182 47.6515)",
    className: "st0",
    width: 17.9,
    height: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2,
    y: 103.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -67.1305 61.9437)",
    className: "st0",
    width: 17.9,
    height: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 73.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -45.036 55.2755)",
    className: "st0",
    width: 17.9,
    height: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.3,
    y: 289.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -80.6132 401.3893)",
    className: "st0",
    width: 17.9,
    height: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 304.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -87.1183 415.6787)",
    className: "st0",
    width: 17.9,
    height: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.2,
    y: 319.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -102.1206 409.4664)",
    className: "st0",
    width: 17.9,
    height: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 27.2,
    className: "st1",
    width: 122,
    height: 63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.8,
    y: 263.2,
    className: "st0",
    width: 46,
    height: 102
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.8,272.2c0,0-40-65-42-82s-4-23-4-23s12-2,16,7s16-2,20,22c0,0,1,12,10,8S73.8,272.2,73.8,272.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,282.2c0,0-28.6-53-38-74c-7-15.6-13-41-13-41s-12.1,4.4-11,14c1,9-8,12-6,23c2.2,11.9,19.4,14.1,9,25 c-6.3,6.6-1.6,17.8,3,25c2.9,4.6,17.4,8.8,14,7C29,257.2,78.8,282.2,78.8,282.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9084 -0.4182 0.4182 0.9084 -85.0054 40.4529)",
    className: "st1",
    cx: 49.8,
    cy: 214.2,
    rx: 2,
    ry: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,314.7c0,0-60.9-46-68.9-61.1s-12.1-20-12.1-20s10.5-6.2,17.5,0.7s14.2-7.7,26.6,13.2 c0,0,1.4,14.7,10.4,11.7C70.1,256.1,87.4,314.7,87.4,314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.7,322.2c0,0-45.9-39-62.3-55.1c-12.2-12-27-33.5-27-33.5s-9.6,8.5-5.2,17c4.2,8-3.1,14.1,2.8,23.6 c6.3,10.3,23.2,6.1,17.5,20c-3.5,8.4,5,17.2,11.9,22.2c4.4,3.2,19.4,1.8,15.6,1.4C40.2,317,95.7,322.2,95.7,322.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6942 -0.7198 0.7198 0.6942 -191.0347 113.3618)",
    className: "st0",
    cx: 37.9,
    cy: 281.5,
    rx: 2,
    ry: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.8,192.3c0,0,47.5-77.3,50.6-97.9s5.6-27.8,5.6-27.8s-13.2-3-18.1,7.8s-17.6-3.1-23.2,25.9 c0,0-1.7,14.6-11.5,9.3S404.8,192.3,404.8,192.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.8,204.2c0,0,34.3-63.2,45.8-88.3c8.5-18.6,16.4-49.3,16.4-49.3s13.2,5.9,11.5,17.5 c-1.6,10.9,8.3,15,5.5,28.3c-3,14.4-22.2,16.3-11.2,30c6.6,8.3,0.9,21.8-4.6,30.3c-3.5,5.4-19.7,9.9-15.9,7.9 C455.1,176.1,398.8,204.2,398.8,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.3,121.7c-7.3,15.6-12.3,28.7-11.2,29.3s7.9-11.5,15.2-27.1s12.3-28.7,11.2-29.4S439.6,106.1,432.3,121.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.6,243.4c0,0,69.8-53.2,79.4-71.3s14.4-23.8,14.4-23.8s-11.3-8-19.4,0.1s-15.3-10-30.2,14.9 c0,0-2.2,17.8-12.1,13.7C409.6,172.9,387.6,243.4,387.6,243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.1,252.2c0,0,52.8-45.4,71.8-64.3c14.1-14,31.6-39.5,31.6-39.5s10.2,10.8,4.9,21 c-5.1,9.6,2.7,17.3-4.2,28.6c-7.5,12.2-26,6.4-20.3,23.6c3.4,10.4-6.4,20.7-14.3,26.5c-5,3.7-21.6,1.3-17.3,1 C439.8,248.3,378.1,252.2,378.1,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M448.2,199.4c-11.4,12.2-20,22.8-19.2,23.8s10.8-8.1,22.2-20.3s20-22.8,19.2-23.8S459.6,187.2,448.2,199.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.8,
    y: 263.2,
    className: "st1",
    width: 77,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 264.2,
    className: "st0",
    width: 77,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 27.2,
    className: "st0",
    width: 50,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.8,
    y: 80.2,
    className: "st1",
    width: 349,
    height: 257
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.8,
    y: 80.2,
    className: "st2",
    width: 340,
    height: 257
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 84.2,
    className: "st3",
    width: 333,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 101.2,
    className: "st0",
    width: 333,
    height: 232
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.8,
    y: 110.2,
    className: "st1",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.8,
    y: 110.2,
    className: "st1",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 110.2,
    className: "st1",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 110.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.8,
    y: 110.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.8,
    y: 110.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.8,
    y: 163.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.8,
    y: 163.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 163.2,
    className: "st2",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 163.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.8,
    y: 163.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.8,
    y: 163.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.8,
    y: 214.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.8,
    y: 214.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 214.2,
    className: "st2",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 214.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.8,
    y: 214.2,
    className: "st2",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.8,
    y: 214.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.8,
    y: 266.2,
    className: "st2",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.8,
    y: 266.2,
    className: "st2",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.8,
    y: 266.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.8,
    y: 266.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.8,
    y: 266.2,
    className: "st1",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.8,
    y: 266.2,
    className: "st3",
    width: 41,
    height: 46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.3,
    cy: 93.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 103.3,
    cy: 93.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 114.3,
    cy: 93.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.3,162.2h28c2.5,0,4.5,2,4.5,4.5l0,0c0,2.5-2,4.5-4.5,4.5h-28c-2.5,0-4.5-2-4.5-4.5l0,0 C92.8,164.3,94.8,162.2,97.3,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.3,214.2h28c2.5,0,4.5,2,4.5,4.5l0,0c0,2.5-2,4.5-4.5,4.5h-28c-2.5,0-4.5-2-4.5-4.5l0,0 C92.8,216.3,94.8,214.2,97.3,214.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.3,266.2h28c2.5,0,4.5,2,4.5,4.5l0,0c0,2.5-2,4.5-4.5,4.5h-28c-2.5,0-4.5-2-4.5-4.5l0,0 C92.8,268.3,94.8,266.2,97.3,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,166.2h16c1.9,0,3.5,1.6,3.5,3.5l0,0c0,1.9-1.6,3.5-3.5,3.5h-16c-1.9,0-3.5-1.6-3.5-3.5l0,0 C141.8,167.8,143.4,166.2,145.3,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.3,179.2h7c1.4,0,2.5,1.1,2.5,2.5l0,0c0,1.4-1.1,2.5-2.5,2.5h-7c-1.4,0-2.5-1.1-2.5-2.5l0,0 C141.8,180.4,142.9,179.2,144.3,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.8,166.2h16c1.7,0,3,1.3,3,3l0,0c0,1.7-1.3,3-3,3h-16c-1.7,0-3-1.3-3-3l0,0 C188.8,167.6,190.1,166.2,191.8,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.8,273.2h16c1.7,0,3,1.3,3,3l0,0c0,1.7-1.3,3-3,3h-16c-1.7,0-3-1.3-3-3l0,0 C324.8,274.6,326.1,273.2,327.8,273.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M372.8,219.2h16c1.7,0,3,1.3,3,3l0,0c0,1.7-1.3,3-3,3h-16c-1.7,0-3-1.3-3-3l0,0 C369.8,220.6,371.1,219.2,372.8,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M371.8,167.2h16c1.7,0,3,1.3,3,3l0,0c0,1.7-1.3,3-3,3h-16c-1.7,0-3-1.3-3-3l0,0 C368.8,168.6,370.1,167.2,371.8,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.8,167.2h16c1.7,0,3,1.3,3,3l0,0c0,1.7-1.3,3-3,3h-16c-1.7,0-3-1.3-3-3l0,0 C323.8,168.6,325.1,167.2,326.8,167.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.8,
    cy: 180.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.8,
    cy: 173.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.8,
    cy: 173.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.8,
    cy: 223.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.8,
    cy: 223.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.8,
    cy: 274.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.8,
    cy: 274.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 160.8,
    cy: 275.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 146.8,
    cy: 275.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 250.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 191.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 205.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 146.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 160.8,
    cy: 119.2,
    r: 4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 298.27 151.936)",
    className: "st1 st5 st6"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.27 151.936)",
    className: "st3 st5 st6"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 162.61 203.736)",
    className: "st1 st5 st6"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 289.6 203.796)",
    className: "st1 st5 st6"
  }, "10"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 247.25 255.566)",
    className: "st1 st5 st6"
  }, "15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 382.25 257.566)",
    className: "st1 st5 st6"
  }, "18"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 195 304.956)",
    className: "st1 st5 st6"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 206.73 304.956)",
    className: "st1 st5 st6"
  }, "0"))), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "women handup")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M139.3,353.3c-1.7-1.1-3.6-2.4-8.4-3.4c-4-0.7-6.3-6.9-6.3-6.9h-9.2c0,0-0.8,10.3-0.4,11.1 c0.4,0.8,0.6,1.7,2.8,2.4c2.1,0.6,20.8,0.4,21.6,0.2C140.1,356.6,142.4,355.3,139.3,353.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.2,254.5c-1.2,1.8-6.7,19.7-6.7,20.6c-0.1,0.9,0.4,3.4,3.2,1.1c1.5-1.3,3.4-2.7,5.7-7.1 c1.9-3.5,8.5-4,8.5-4l2.8-8.7c0,0-9.6-3.9-10.5-3.8C34.3,252.7,33.4,252.7,32.2,254.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1028.486,
    y1: 1463.6387,
    x2: 1119.9896,
    y2: 1463.6387,
    gradientTransform: "matrix(1 0 0 1 -985.94 -1183.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F68CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5ACEED"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M92.8,222.1c-0.2,0.1-0.5,1.8-0.6,2c-1.4,4.4-14.2,43.4-14.2,45c0,1.7-27.5-10.8-31.9-12.7 c-0.4-0.2-0.7,0-0.9,0.3c-0.9,1.9-3.4,7.5-2.5,8.2c1.1,0.8,30,21.4,32.4,22c2.4,0.6,5.9,3.5,11.8-3.5c5.1-6.1,19.3-29.1,23.2-35.6 c0.2-0.3,0.6-0.4,0.9-0.2c0.2,0.1,0.3,0.3,0.4,0.5c0.7,6.2,1,30.2,3.1,36.7c2.1,6.4-0.9,13.3-0.9,22.8l1.7,34.8 c0,0.4,0.3,0.6,0.6,0.6l8,0.2c0.4,0,0.6-0.2,0.7-0.6c0.5-5.6,5.8-47.7,6.3-54.2c0.6-7.1,4-66.6,3.1-70.2 C133.3,215.9,97.2,221.4,92.8,222.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1072.0259,
    y1: 1314.0358,
    x2: 1126.599,
    y2: 1314.0358,
    gradientTransform: "matrix(1 0 0 1 -985.94 -1183.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F87B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F8C548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F89C51"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.8,117.4c0,0,2-8,3.6-8s11.3,1.2,12.5,6.9c1.2,5.7,5.6,8.9,5.6,15.7c0,6.9,2.8,10,2.8,10s3.2-10.1,5.6-14.5 c2.4-4.4,6.6-7.1,6.6-10.1s-3.5-36.5-3.8-37.4s-1.2-6.2,0.9-9.2c0,0,6.4-5.3,7.2-7.4c0.6-1.8,2.7-2.8,3.9-0.7 c1.2,2.1-3.7,7.7-4.5,9.9c-0.7,2.1-1.2,4.3-1.5,6.6c0,0.6-1.2,9.5-1.2,13.9s2.7,18.4,2.7,22.9c0,4.4-9.8,22.2-10.7,25.5 s-29.4,34.4-30,35.3c-0.6,0.9-3.5,7.7-3.5,10.1s0,10.1,1.2,8.6c1.2-1.5,6.1-13.3,7-14.8c0.9-1.5,7.9-2.9,11.2-3.8s8.2,0.9,7.6,3 c-0.6,2.1-10.2,6-13.3,6.7c-1.9,0.5-10.4,9.8-11,12.5c-0.6,2.7-8.3-1.2-8.3-5c0-3.8,0.9-23.4,2.1-26.1c1.2-2.7,6.6-14.2,9.5-20.2 c3-6-3.5-8.9-4.7-13.1C91.8,130.6,95.8,117.4,95.8,117.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1072.1061,
    y1: 1363.7703,
    x2: 1157.4636,
    y2: 1304.3607,
    gradientTransform: "matrix(1 0 0 1 -985.94 -1183.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7658F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1A1ED"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M121.3,136.4c0,0,7.7-13.9,8.5-17.4c0.8-3.5-1.2-39.1-1.2-39.1l6-0.9c0,0,5.7,33,6.5,36.9 c0.8,3.8-2,12.1-4.7,16.8c-2.7,4.7-10,24.2-10,26.5s0.5,24.2,1.7,28.5c1.2,4.3,6,30.7,6,30.7l-41.3,3.9c0,0,1.8-11.5,1.7-15.4 c-0.3-8.4-2.6-14.7,3.5-18.7c4.1-2.6,8-1.4,12.5-3.5c5.1-2.5,6.3-4.6,6.6-6c0.2-0.8-1.1-2.7-9.1,0.2c-2.7,1-8,0.9-8.2,4.4 c-0.1,2.9,3.7,9.2-0.8,12c0,0-5.1,12.1-9.9,14c-4.1,1.6-9-2.8-8.9-8.5c0.1-6.9,0.5-20,3.7-25.7c3.1-5.7,11.7-20.4,13.2-21.6 c1.5-1.2,6.2,4.4,11.6,3.7c5.4-0.8,7.7-3.3,8.9-6C118.7,148.4,121.3,136.4,121.3,136.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1068.2401,
    y1: 1325.9875,
    x2: 1120.7048,
    y2: 1325.9875,
    gradientTransform: "matrix(1 0 0 1 -985.94 -1183.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4B44BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BD3EF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104,111.1c2.4,3.9,5.6,7.3,9.2,10c6.3,4.8,0.1,18.3-0.2,25c-0.2,5.4,3,12.8,10.7,17.8 c5.6,3.7,1.7,11.9,1.7,16.1c0,4.1,9-5.8,9.3-10.6c0.4-5.8-1.1-10-5.2-14.7c-3.8-4.4-8.3-21-9.6-28.9c-0.1-0.8-0.2-1.6-0.1-2.4 c0.1-2.8-0.2-11.6-8.2-16.5c-9.5-5.9-15.4-0.5-19.2,2.8c-4.7,4-6.6,15-5.4,32.1s-1.8,26.9-3.8,31.8c-4.6,11.3,7.9,3.4,10.2-3.1 c3-8.3,5-9,9.2-15.5c1.7-2.5-0.5-11.2-2.4-14.8c-3.5-7-5.5-9.9-5.5-14.6S100.5,112.9,104,111.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.9,141.7c0,0,6.7,0.4,8.5-3.8c0.2-0.5-1.1,13-1.4,11.2C112.5,147.3,105.9,141.7,105.9,141.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.2,104.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.1,172.9c0,0-1.5,9.6-2.4,13.9c-0.5,2.4-0.8,4.7-0.8,7.1c0,0,5.7-7.1,7.5-9.9c1.1-1.8-2.3-0.9-2.6-7.4 S95.6,166,95.6,166L94.1,172.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.6,203.6c0,0,5.1-5,5.3-7.6c0.3-3.4,2.7-3.2,2.7-1.1c0,2.1-3.8,18-1.5,22.2c2.3,4.2,4.1,4.1,4.1,4.1 l-12.4,0.9L94.6,203.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.2,221.2c0,0,0.7,12.6-3.8,16.8c-9.2,8.6-3.8,19.8-7.9,24.7c-3.4,4.1-4.3,15.8-12.5,18.4 c-3.2,1.1-14.9-6.1-17.3-6.9c-5-1.7-8.6-11.3-24.2-16.3c-3.7-1.2,9.6,0.1,9.6,0.1L78,270l14.9-47.8L105.2,221.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "man_with_ipad"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M370.4,334.2l-1.4,0l-7.5,0.1c0,0-1.6,7.7-2.5,10.9c0,0.2-0.2,0.7-0.3,1.1c-0.1,0.6-0.2,1.1-0.2,1.7 c0.2,2.9,1.2,5.4,3.9,6.7c2.9,1.4,5.1,2.8,8.1,0s3.5-4.5,2.3-9.4C371.5,340.5,371.1,334.3,370.4,334.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M401.9,343.8L401.9,343.8c-5.2-1.6-8.7-8.7-8.7-8.7l-8.9-0.5c0,0-0.5,7.2-0.7,10.8c-0.3,4.8,0.5,7,3.7,6.7 c4.2-0.3,21.2,1.2,23.9-0.5C414.7,349.3,406.7,345.3,401.9,343.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.7526,
    y1: 395.132,
    x2: 403.6012,
    y2: 395.132,
    gradientTransform: "matrix(1 0 0 1 0 -124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F68CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5ACEED"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M348.8,207v10.6l12.8,116.7h9.1c0,0,3.1-80,3.1-82.8s0.8-11.5,0.8-11.5s11.4,32.9,11.6,35.6 c0.2,2.7-1.9,59.4-1.9,59.4l9.1,0.4c0,0,7.9-38.3,7.9-41.9c0-3.6,2.7-22.5,2.3-26.1c-0.4-3.6-7.1-60-7.1-60l-13.9-0.4L348.8,207z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.0365,
    y1: 270.0442,
    x2: 410.4936,
    y2: 270.0442,
    gradientTransform: "matrix(1 0 0 1 0 -124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F87B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F87B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#F89453"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F8C548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F89C51"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M407.5,194.7l-0.1-0.2C407.4,194.7,407.4,194.8,407.5,194.7 M380.9,184.5l-5.1,2.1l-0.3,7l5.6,2.2 c0,0,6.1-0.2,6.1-0.3c0-0.3,2.4-0.2,3.5,0.5l19-6.5l0.7-4.5c0,0,1.4,5.7-4.9-5.8L380.9,184.5z M403.5,161.4l-0.4-2.3l-1-0.2 L403.5,161.4 M368.5,100.4c-2.3,1-3.5,4.4-3.5,4.4s-1.1-0.7-1.1,1.2c0,1.9,1,6.3,1.6,7.4c1.2,1.9,2.3,3.8,3.3,5.8 c0.9,2,0.6,6.1-0.4,6.7c-1,0.6-18.2,16.1-18.2,16.1L336,185.7v1.7l2.2,0.8l2.3,1.9c0.2,0,3.1,1.6,3.5,1.9c2.3,1.1,4.7,2,7.1,2.5 c1.6,0.3,8.7,0.2,8.7,0.2l7.2-0.2l-1.2-9.2l-10.7-0.1l-14.6-0.7l14.8-34l46.6,8.3c-8.3-15-17.6-31.8-18.4-33.6 c-0.7-1.4,0-4.9,0.4-6.7c0.4-1.6,1.2-3.7,1.9-4.3c0.8-0.6,2.1-3.3,2.1-4.4s0.3-5.7-0.6-4.7c-0.3,0.3-1.4-1.4-1.8-3.2 c-0.6-2.5-2.4-4.3-4.4-5.9c0,0-10.3,3.4-12.6,4.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.0836,
    y1: 296.623,
    x2: 411.785,
    y2: 296.623,
    gradientTransform: "matrix(1 0 0 1 0 -124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1A1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7658F4"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M350.6,132.7c-2.3,1.5-4.3,3.6-5.1,6.2c-0.8,2.7-6.2,23.3-6.9,26c-1.8,6.4-2.8,8.2-4.9,15.8 c-2.6,9.3,3.3,10.7,9.4,12c6.3,1.4,6.3,2,7.8,2c0.2,0,7.7,1.5,7.9-2.7c0.2-2.7-0.3-6.9-1.3-6.8c-2.3,0.3-9.7-1.6-10.1-1.9 c-0.5-0.3,1.6-6.1,2.8-9.7c0.9-2.7,4.3-13.7,5.1-15.7c0.4-1.1-1.9,10.7-3.3,22.3c0,0.4-0.6,4.9-0.4,4.9c1.7,0,6.3,0.1,7.8,0.2 c6.5,0.8,7.8,3.9,7.4,6.4c-0.7,4.3-16.6,2.3-16.5,2.9c0,0-2.7,12.3-1.2,13.1c1.3,0.7,19.1,8.1,22.9,9.5c0.4,0.2,0.9,0,1-0.5 c0,0,0,0,0,0l2.4-6.9c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0.1l2.3,7.6c0,0.2,0.2,0.4,0.4,0.4h1l19.8-4.3c0,0-0.1-7.8-0.1-17.8 c0-1-0.2-4.7-0.9-4c-0.7,0.7-17.2,2.9-19,2.1c-3.8-1.6-2.8-5.6-1.5-7.2c1.5-1.9,21-2.8,21.1-4.2c0.3-6.1-0.2-22.2-0.5-20.2 c-0.5,3-11.9,19.5-11.9,22.4c0,2.9-0.2,10.1-0.2,10.1l18.7-1.4c0,0,6.3-2.2,6.8-5.8c0.6-3.6-0.1-5.2-0.4-10.6 c-0.2-3.4-5-24-6.4-29.8c-0.2-0.9-0.3-1.8-0.4-2.7c-0.2-2.4-1.1-8-6.3-10.5c-6.4-3.1-11.5-5.5-12.8-5.5c-1.2,0-4.5,7.2-6.2,9.3 c-0.8,0.9-0.6,1.4-1.6,2.7c-0.5,0.7-1.5,0.8-2.2,0.4c-0.2-0.1-0.3-0.3-0.4-0.4c-0.6-0.8-1-1.7-1.5-2.6c-0.8-1.5-6.7-10.3-6.7-10.3 S352.9,131.1,350.6,132.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.4299,
    y1: 221.7154,
    x2: 388.6291,
    y2: 221.7154,
    gradientTransform: "matrix(1 0 0 1 0 -124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5ACEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#4F68CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5282D3"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M381.1,96.1c0,0-12.6,4.7-13.5,5.4s-2.6,3.3-2.6,3.3s-0.9-0.5-1.1,0.8c0,0-1.3-2.7-1.4-4.1 c-0.2-1.5,0-5.3,2.4-7.8c2.4-2.5,7.3-5.9,10.3-5.4c3,0.4,4.3,0.8,6.2,2.7c1.9,1.9,3.5,2.5,4.1,2.7c0.6,0.3,2.7,1.9,3.1,4.8 s-0.6,8.8-0.6,8.8s0.3-2.3-0.6-1.6c-0.6,0.5-1.6-1.6-1.9-2.9C385,101.6,381.8,96.5,381.1,96.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 377.2,
    y: 119.6,
    width: 8.4,
    height: 13.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.3,128.3c-0.1-0.2,1.4,0.8-0.3-0.4c-2.4-1.7-1.2-8.8-1.2-8.8c-0.9,1.9-2.4,3.3-4.3,4c-3,1.1-3.9,0.3,0.7,3 c4.6,2.7,2.2,3.6,1.9,7.1"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 381.2,
    y: 144.9,
    width: 23.3,
    height: 40.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.6,153.4l6.3,23.8c0,0,0,4.2-1.3,4.9c-1.2,0.6-5.2,1-6.1,1.4c-0.9,0.4-10.5,2.4-8-1c0.6-0.8,13.6-5.3,7.8-10.1 c-5.8-4.8-4.8-11.4-2-16c2.8-4.6,2.2-8.5,2.2-8.5L394.6,153.4z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 346.7,
    y: 207.2,
    width: 19,
    height: 144.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368,216.1c0,0-5.4,28.8-2.6,40.3c4.3,17.5-1.9,41.1-1.9,52.4c0,7.4,2.9,27.7,3.1,36c0,2.5,1.9,7.3,0.5,8.5 c-0.6,0.5-4-0.6-5.9-1.5c-1-0.5-1.6-1.5-1.4-2.6l1.1-4.9l1.6-6.5l-11.3-105.4c0,0-3.6-23.5-1.6-23.5 C351.7,208.7,368,216.1,368,216.1"
  }))))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M362.8,177.3l21.3,2.7c0.4,0.1,0.7,0.5,0.7,1l-0.6,19.2c0,0.6-0.4,1.4-1,1.2l-21.2-4.1 c-0.4-0.1-0.7-0.5-0.7-0.9l-0.1-2.1l2.3-0.6c0.6-0.2,1.2-0.5,1.6-0.8c0.1-0.1,0.2-0.2,0.3-0.3l0.5-0.7c0.2-0.2,0.2-0.5,0.2-0.8 c-0.1-0.4-0.2-1-0.3-1.4c0-0.1-0.1-0.2-0.1-0.3l-0.5-1.1c-0.2-0.5-0.6-0.9-1.2-1.2l-0.3-0.2l-2.3-1.2l0.2-7.5c0-0.5,0.4-0.9,1-0.9 C362.8,177.3,362.8,177.3,362.8,177.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Pig with coins")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1083.6315,
    y1: 1072.3805,
    x2: 1049.9227,
    y2: 1047.8867,
    gradientTransform: "matrix(1 0 0 1 -935 -1005.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9B449"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M112.1,52.9l4.9-0.3c0,0,1-5.9,4.9-7.8v-6.5c0,0,4.6,2.6,5.5,2.9c1,0.3,9.8-3.9,19.8,2.3 c8.5,5.2,6.6,14.3,5.8,17.1c-0.1,0.5-0.4,1-0.7,1.4c-0.7,1-2.1,2.9-2.8,3.6c-1,1,0.6,6.4-0.7,6.8c-1,0.3-2.9-3.9-3.9-3.6 c-5.2,1.8-10.9,2-16.3,0.5c-0.4-0.1-0.7,0.1-0.9,0.4c-0.4,0.9-1.3,2.5-2,3c-1,0.7-1-3.6-2-4.2s-11.7-10.1-11.7-10.1V52.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M152.9,53.9c0,0,4-2.8,6.1-0.7s1.8,4.3,0.1,4.8c-1.3,0.4-3.3-1.8-2.4-3.1s2.4-2.1,4.1-1 c1.7,1.1,2.5,3.5,2.6,4.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 122.5,
    cy: 53.3,
    r: 1.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1064.4366,
    y1: 1047.3831,
    x2: 1077.4348,
    y2: 1047.3831,
    gradientTransform: "matrix(1 0 0 1 -935 -1005.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F93764"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M130,42.3c0,0,7.3-2,12,0.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "coin"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.6265,
    y1: 637.9296,
    x2: 140.4618,
    y2: 617.3215,
    gradientTransform: "matrix(1 0 0 1 0 -596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9B449"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 136.1,
    cy: 27.8,
    r: 7.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.5839,
    y1: 623.8522,
    x2: 142.4845,
    y2: 623.8522,
    gradientTransform: "matrix(1 0 0 1 0 -596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F93764"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 136,
    cy: 27.9,
    r: 6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 133.6808 30.5892)",
    className: "st28 st29 st30"
  }, "$"))), /*#__PURE__*/React.createElement("g", {
    id: "coin_copy"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.3155,
    y1: 619.8466,
    x2: 147.423,
    y2: 606.2779,
    gradientTransform: "matrix(1 0 0 1 0 -596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9B449"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 144.6,
    cy: 14.6,
    r: 4.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1074,
    y1: 610.5859,
    x2: 148.9409,
    y2: 610.5859,
    gradientTransform: "matrix(1 0 0 1 0 -596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F93764"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 144.5,
    cy: 14.6,
    r: 3.9
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 142.9709 16.387)",
    className: "st28 st29 st33"
  }, "$"))), /*#__PURE__*/React.createElement("g", {
    id: "coin_copy_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.961,
    y1: 620.3771,
    x2: 129.4803,
    y2: 610.668,
    gradientTransform: "matrix(1 0 0 1 0 -596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9B449"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 127.4,
    cy: 17.7,
    r: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.1032,
    y1: 613.7399,
    x2: 130.7103,
    y2: 613.7399,
    gradientTransform: "matrix(1 0 0 1 0 -596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F93764"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st35",
    cx: 127.4,
    cy: 17.7,
    r: 2.8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 126.3 19.0433)",
    className: "st28 st29 st36"
  }, "$")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg41);
export default __webpack_public_path__ + "static/media/bg4-1.488b246b689282d36c36332988065fa6.svg";
export { ForwardRef as ReactComponent };